<template  class="feed-table">
  <el-row>
    <!-- type="white-header-table" -->
    <er-data-tables
      :table-data="tableDataArr"
      v-loading="loading"
      :filters="filters"
      :columns="tableColumns"
      type="white-header-table"
      :el-table-props="tableProps"
      :pagination-props="$constants.table['pagination-props']"
      :actionColumn="false"
      :expand-column="true"
      uniqueId="stock-feed-table"
      @expand-change="handleExpandChange"
    >
      <!-- v-loading="expandloading === row.data.feed_id" -->
      <template v-slot:expandColumn="{ row }">
        <er-data-tables
          :tableData="getExpandedTableData(row.data)"
          :columns="expandedTableColumns"
          :el-table-props="tableProps"
          :action-column="false"
          unique-id="harvest-yield-inner-table"
          type="white-header-table-inner"
          layout="table"
        >
          <template v-slot:actions="{ row }">
            <er-button
              type="text"
              size="mini"
              btnType="edit"
              :showLabel="true"
              :showIcon="true"
            ></er-button>
            <!-- @click=" handleClickAction($event, 'edit',
            $lodash.cloneDeep(row.data)) "
            :disabled="disabledEditAndDelete(row.data) || isReadOnly"
            :disabled="disabledEditAndDelete(row.data) || isReadOnly"
            @click="handleRemoveResource($event, row.data)" -->
            <el-divider direction="vertical"></el-divider>
            <er-button
              type="text"
              size="mini"
              btnType="delete"
              :showLabel="true"
              :showIcon="true"
            ></er-button>
          </template>
        </er-data-tables>
      </template>

      <template v-slot:feed_name="{ row }">
        <!-- <div class="alias-name-container"> -->

        <p>{{ row.data.feed_name | na("-", false) }}</p>

        <!-- </div> -->
      </template>
      <template v-slot:actions="{ row }">
        <span class="button-size">
          <er-button
            type="text"
            size="mini"
            btnType="edit"
            :showLabel="true"
            :showIcon="true"
            :disabled="isReadOnly"
            @click="handleEditFeedObj"
          ></er-button>
          <el-divider direction="vertical" style="height:100%;"></el-divider>
          <er-button
            type="text"
            size="mini"
            btnType="delete"
            :showLabel="true"
            :showIcon="true"
            :disabled="isReadOnly"
            @click="handleFeedDelete(row.data)"
          ></er-button>
        </span>
      </template>
    </er-data-tables>
  </el-row>
</template>

<script>
import Feed from "@/model/feed";
import { mapGetters } from "vuex";
import filtersMixin from "@/mixins/filtersMixin.js";
import feedData from "./feedData.json";

export default {
  mixins: [filtersMixin],
  data: function() {
    return {
      loading: false,
      tableDataArr: feedData,
      tableProps: {
        // border: true,
        size: "small"
      },
      expandTableData: feedData,
      filters: [
        {
          value: "",
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (["feed_name"].indexOf(prop) > -1) {
                return row[prop]
                  .toLowerCase()
                  .includes(filter.value.toLowerCase());
              }
            });
          }
        }
      ]
    };
  },
  computed: {
    ...mapGetters("user", {
      isReadOnly: "isReadOnly"
    }),
    tableColumns() {
      return {
        feed_name: {
          prop: "feed_name",
          label: this.$t("Comn_feed_name"),
          minWidth: "100",
          align: "left"
        },
        available_stock: {
          prop: "available_stock",
          label: this.$t("Stock_avail_stock"),
          minWidth: "100",
          align: "left"
        },
        last_purchased_quantity: {
          prop: "last_purchased_quantity",
          label: this.$t("Stock_last_purchased_qty"),
          minWidth: "100",
          align: "left"
        },
        last_updated_date: {
          prop: "last_updated_date",
          label: this.$t("Comn_last_updated"),
          minWidth: "80",
          align: "left"
        }
      };
    },
    expandedTableColumns() {
      return {
        units: {
          prop: "units",
          label: this.$t("Comn_no_of_units"),
          minWidth: "100",
          align: "left"
        },
        unit_Quantity: {
          prop: "unit_Quantity",
          label: this.$t("Comn_unit_quantity"),
          minWidth: "100",
          align: "left"
        },

        quantity_purchased: {
          prop: "quantity_purchased",
          label: this.$t("Quantity_purchased"),
          minWidth: "100",
          align: "left"
        },
        vendor_name: {
          prop: "vendor_name",
          label: this.$t("Resource_vendor"),
          minWidth: "100",
          align: "left"
        },

        purchase_resource_date: {
          prop: "purchase_resource_date",
          label: this.$t("purchase_resource_date"),
          minWidth: "80",
          align: "left"
        },
        actions: {
          prop: "actions",
          label: this.$t("Comn_actions"),
          minWidth: "100",
          align: "left"
        }
      };
    },
    getExpandedTableData() {
      return x => {
        return this.expandTableData;
      };
      return [];
    }
  },
  methods: {
    handleFeedDelete(resource) {
      console.log("delete", resource);
    },
    handleEditFeedObj(resource) {
      console.log("edit", resource);
    },
    async handleExpandChange(row) {
      try {
        if (row.feed_id) {
          const expandTableData = this.tableDataArr;

          console.log(expandTableData, "Expanded");
          // this.$set(this.pondIdToHarvestData, row.pond_id._id, expandTableData);
        }
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.expandloading = "";
      }
    }
  }
};
</script>

<style lang="scss">
.feed-table {
  // .pagination-bar {
  //   display: flex;
  //   justify-content: center;
  //   margin-top: 0px !important;

  //   .el-pagination {
  //     margin-top: 20px !important;
  //     margin-bottom: 20px !important;
  //   }
  //   .el-pagination__total {
  //     margin-right: 0rem !important;
  //     margin-left: 1rem;
  //   }
  // }
}
</style>
